import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../store';
import * as UserActions from '../../../store/actions/user.actions';
import * as ModalActions from '../../../store/actions/modal.actions';
// import * as ModalActions from '@ibe/store/actions/modal.actions';

import { INDRAAuthenticationService } from '@ibe.services/authentication.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';


import { 
	SESSION_VAR_KEY_LANGUAGE, 
	SESSION_VAR_KEY_MARKET, 
	DEFAULT_LANGUAGE, 
	DEFAULT_MARKET,
	UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE,
	LOGIN_AUTENTICATION_TYPE_GOOGLE, 
	SOCIAL_GOOGLE_KEY
} from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-login-modal',
	templateUrl: './login-modal.indra.component.html',
	styleUrls: ['./login-modal.component.scss'],
	host: { 'class': 'modal--login' }
})
export class INDRALoginModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {
	isAlive = true;
	infoLoading = true;

	userLoggedIn = false;
	userInfo;

	loginError = false;
	loginErrorMessage: any;
	loginErrorMessageTitle: any;
	invalidAttempts: any;
	loginErrorUsernameRelated = false;
	loginErrorPasswordRelated = false;
	messages: any;
	translatedMessagesKey: any;
	translatedMessagesTitleKey: any;

	form: FormGroup;

	loginData = {
		login: null,
		// username: null,
		password: null
	};

	private loading$: Observable<boolean> = this.store.select(fromStore.getUserLoading);
	private logged_in$: Observable<boolean> = this.store.select(fromStore.getLoggedIn);
	private user_info$: Observable<boolean> = this.store.select(fromStore.getUserInfo);
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	isCorporate: boolean = false;
	// label: string;
	
	hideClose: boolean = false;
	
	private timeToThink_to_booking$: Observable<Object> = this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
	isTTTBookingPayment: boolean = false;
	account: string = '';
	
	bookedTripDiscounts$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripDiscounts);
	bookedTripDiscounts: Array<any> = [];
	isBookingPaymentPage: boolean;
	

	public lottieConfig: Object;
	private anim: any;
	public passwordIsHidden: boolean = true;

	public isSubmitted = false;
	userPNRS: any;
	
	public gapiSetup: boolean = false; // marks if the gapi library has been loaded
	public authInstance: gapi.auth2.GoogleAuth;
	public error: string;
	public user: gapi.auth2.GoogleUser;

	PassFilled = false;
	UserFilled = false;
	PassFocused = false;
	UserFocused = false;

	constructor(
		protected modalService: ModalService,
		private fb: FormBuilder,
		private store: Store<fromStore.State>,
		private sidebarService: SidebarService,
		private router: Router,
		private authenticationService: INDRAAuthenticationService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private storage: INDRAStorageService,
		private ibeAdminService: INDRAIbeAdminService
	) {
		super(modalService);
		this.lottieConfig = {
			path: './assets/animations/show.json',
			renderer: 'svg',
			autoplay: false,
			loop: false
		};
		
		/* note: from post sprint 8 merge
		this.isCorporate$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isCorporate = value;
				if (value === true) {
					this.isCorporate = true;
					this.label = 'Username';
					if (this.isTTTBokingPayment) {
						this.TAP_disableCloseModal();
					} else {
						this.TAP_enableCloseModal();
					}
				} else {
					this.isCorporate = false;
					this.label = 'Email or Customer Number';
				}
			});
		*/
		
		this.messages = {
			userUnknown: '10078.TAP.F User unknown',
			invalidCredentials: '10078.TAP.F - Invalid username/password - Invalid attempts: ',
			invalidUsernameOrPassword: '1.1.LDAP - Invalid attempts: ',
			loginServiceUnavailable: 'Login service unavailable',
			emailMultipleClients: '10078.TAP.F - Too many clients for given email',
			costumerDataError: '700.TAP - Target Provider Error - CDH',
			accountLocked: '10078.TAP.F - Account Locked',
			tryLater: 'Something went wrong. Try again later',
			unauthorized: '401 Unauthorized'
		};

		this.translatedMessagesKey = {
			userUnknown: 'header.login.error.userUnknown',
			invalidCredentials: 'header.login.error.invalidCredentials',
			loginServiceUnavailable: 'header.login.error.loginServiceUnavailable',
			emailMultipleClients: 'header.login.error.emailMultipleClients',
			accountLocked: 'header.login.error.accountLocked',
			costumerDataError: 'header.login.error.costumerDataError',
			tryLater: 'header.error.tryLater',
			invalidStatus: 'header.login.error.invalidStatus',
			unauthorized: 'header.login.error.unauthorized',
		};

		this.translatedMessagesTitleKey = {
			userUnknown: 'header.login.error.userUnknown.title',
			invalidCredentials: 'header.login.error.invalidCredentials.title',
			loginServiceUnavailable: 'header.login.error.loginServiceUnavailable.title',
			emailMultipleClients: 'header.login.error.emailMultipleClients.title',
			accountLocked: 'header.login.error.accountLocked.title',
			costumerDataError: 'header.login.error.costumerDataError.title',
			tryLater: 'header.error.tryLater.title'
		};
		
		this.timeToThink_to_booking$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.isTTTBookingPayment = true;
					this.account = value['account'] ? value['account'] : '';
					/* note: from post-sprint 8 client code merge
					if (this.isCorporate) {
						this.TAP_disableCloseModal();
					} else {
						this.TAP_enableCloseModal();
					}
					*/
				}
			});
			
		this.bookedTripDiscounts$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(discounts => {
				this.bookedTripDiscounts = Object.assign([], discounts);
			});
			
		if (this.router.url.includes('/booking/payment')) {
			this.isBookingPaymentPage = true;
		}
	}

	ngOnInit() {
		/* note: from post-sprint 8 client code merge
		if (this.isCorporate == true) {
			this.form = this.fb.group({
				login: [''],
				username: [
					this.account,
					[
						Validators.required,
						Validators.pattern('^[a-z0-9_.]+$'),
						Validators.minLength(6),
						Validators.maxLength(15)
					]
				],
				password: ['', [Validators.required]]
			});
		} else {
			this.form = this.fb.group({
				username: [''],
				login: [
					this.account,
					[
						Validators.required,
						Validators.pattern('^(.+@.+\..+|([0-9]{9}))$')
					]
				],
				password: ['', [Validators.required]]
			});
		}
		*/
		this.form = this.fb.group({
			login: [
				this.account,
				{
					validators: [
							Validators.required,
							this.validateUsername
						],
					updateOn: 'blur'
				}
			],
			password: [
				'', 
				[
					Validators.required,
					Validators.minLength(8),
					Validators.maxLength(32)
				]
			]
		});

		this.loading$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.infoLoading = value;
		});

		this.logged_in$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.userLoggedIn = value;
		});

		this.user_info$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.userInfo = value;
		});

		/* this.form.valueChanges.subscribe(value => {
			// this.isSubmitted = false;
		}); */
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	get login() {
		return this.form.get('login');
	}
	
	/*
	get username() {
		return this.form.get('username');
	}
	*/

	get password() {
		return this.form.get('password');
	}

	isInvalid(field: string) {
		return this.form.get(field).invalid && this.isSubmitted;
	}

	cancel() {
		this.store.dispatch(new UserActions.PutCancelLogIn(true));
		this.closeModal();
	}

	closeModal() {
		this.modalService.close();
	}
	
	INDRA_isLoginErrorStatus(status: string): boolean {
		switch (status) {
			case '400':
				return true;
			case '401':
				return true;
			case '404':
				return true;
			case '406':
				return true;
			case '422':
				return true;
			case '503':
				return true;
			case '500':
				return true;
			case '200':
				return false;
		}
	}

	async INDRA_submitLogin() {
		this.isSubmitted = true;
		this.loginErrorUsernameRelated = false;
		this.loginErrorPasswordRelated = false;
		this.loginErrorMessage = null;
		this.loginErrorMessageTitle = null;
		
		if (this.form.valid) {
			this.store.dispatch(new UserActions.LoadingAction());
			// Update store
			this.userLoggedIn = true;
			// initiate login process
			const login = this.form.get('login').value;
			const password = this.form.get('password').value;
			this.form.get('login').disable();
			this.form.get('password').disable();
			this.store.dispatch(new ModalActions.PutShowCloseAction(false));
			this.authenticationService.INDRA_login(login, password).subscribe(response => {
				if (this.INDRA_isLoginErrorStatus(response.status)) {
					this.loginError = true;
					if (response.errors)
						this.INDRA_handleLoginErrors(response.errors);
					this.form.get('login').enable();
					this.form.get('password').enable();
					
					this.store.dispatch(new UserActions.LoadingAction(false)); // explicitly stop user loader
					
				} else {
					if(response.data) {
						
						const { userProfile, userAddress, defaultCurrency} = response.data;
						const userData = {
							...userProfile,
							userAddress: userAddress,
							userProfile: userProfile,
							defaultCurrency: defaultCurrency
						};
						
						this.storage.set('userData', userData);
						this.userInfo = { ...userProfile, defaultCurrency};
						this.store.dispatch(new UserActions.PutLoggedInAction(this.userLoggedIn));
						this.store.dispatch(new UserActions.PutUserInfoAction(this.userInfo));
						
						if (!this.userInfo.ffLevel) {
							/* // commented out since club tap handling is not yet in scope or available from the API
							this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
							this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
							*/
						}
						
						this.closeModal();
						
						if (!this.userInfo.ffLevel && this.isBookingPaymentPage && this.bookedTripDiscounts.length > 0) {
							this.sidebarService.openSidebar(['upgrade-miles-and-go'], [{source: UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE}]);
						}
						
					} else {
						this.loginError = true;
						this.isSubmitted = false;
						this.form.get('login').enable();
						this.form.get('password').enable();
					}
				}	
				this.store.dispatch(new ModalActions.PutShowCloseAction(true));
			}, () => {
				this.store.dispatch(new ModalActions.PutShowCloseAction(true));
				this.isSubmitted = false;
			});
		}
	}
	
	INDRA_socialLogin(username: string, type: string) {
		this.isSubmitted = true;
		this.loginErrorUsernameRelated = false;
		this.loginErrorPasswordRelated = false;
		this.loginErrorMessage = null;
		this.loginErrorMessageTitle = null;
		// this.loginLoading = true;
		this.store.dispatch(new UserActions.LoadingAction());
		this.form.get('login').disable();
		this.form.get('password').disable();
		this.userLoggedIn = true;
		
		this.authenticationService.INDRA_SocialLogin(username, type).subscribe((response) => {
			if (this.INDRA_isLoginErrorStatus(response.status)) {
				this.loginError = true;
				// this.loginLoading = false;
				if(response.errors)
					this.INDRA_handleLoginErrors(response.errors);
				this.form.get('login').enable();
				this.form.get('password').enable();
				
				this.store.dispatch(new UserActions.LoadingAction(false)); // explicitly stop user loader
			} else {
				if (response.data) {

					const { userProfile, userPnrs, userAddress, defaultCurrency} = response.data;
					
					// this.loginModalService.sendDataCustomer(response.data);

					const userData = {
						...userProfile,
						userPnrs: userPnrs,
						userAddress: userAddress,
						userProfile: userProfile,
						defaultCurrency: defaultCurrency
					};

					this.storage.set('userData', userData);
					this.userInfo = { ...userProfile, defaultCurrency};
					this.store.dispatch(new UserActions.PutLoggedInAction(this.userLoggedIn));
					this.store.dispatch(new UserActions.PutUserInfoAction(this.userInfo));
					// this.store.dispatch(new UserActions.PutUserPNRSAction(userPnrs));

					/*
					if (this.data != null && this.data.length === 2) {
						this.router.navigate([this.data[0]], {queryParams: this.data[1]});
					} else if (this.data != null && this.data.length === 1) {
						this.router.navigate([this.data[0]]);
					} else {
						// this.router.navigate(['./']);
						window.location.reload();
					}
					*/
					
					this.closeModal();
					
					if (!this.userInfo.ffLevel && this.isBookingPaymentPage && this.bookedTripDiscounts.length > 0) {
						this.sidebarService.openSidebar(['upgrade-miles-and-go'], [{source: UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE}]);
					}
				} else {
					this.loginError = true;
					// this.loginLoading = false;
					this.isSubmitted=false;
					this.form.get('login').enable();
					this.form.get('password').enable();
				}
				this.store.dispatch(new ModalActions.PutShowCloseAction(true));
			}
		}, (err) => {
			this.store.dispatch(new ModalActions.PutShowCloseAction(true));
			this.isSubmitted=false;
			console.log(err);
		});
	}
	
	
	
	INDRA_getUserPNRs(tapID, ffNumber) {
		return new Promise(resolve => {
			this.authenticationService.INDRA_getUserReservations(tapID, ffNumber).subscribe(response => {
				if (response && response.data) {
					this.store.dispatch(new UserActions.PutUserPNRSAction(response.data));
				}
				resolve();
			}, () => {
				resolve();
			});
		});
	}
	
	validateUsername(c: FormControl) {
		const EMAIL_REGEXP = /[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}/;
		const TAP_NUMBER_REGEX = /^\d{9}$/;
		const NUMBER_REGEX = /^\d+$/;

		if (EMAIL_REGEXP.test(c.value) || TAP_NUMBER_REGEX.test(c.value)) {
			return null;
		}

		return {
			valid: false,
			error: NUMBER_REGEX.test(c.value) ? 'tapNo' : 'email'
		};
	}

	getLoginFieldError() {
		if (this.login.errors) {
			switch (true) {
				case this.login.errors.required: return 'header.login.errorLoginRequiredOrInvalid';
				case this.login.errors.error === 'tapNo': return 'header.login.invalidTapNo';
				case this.login.errors.error === 'email': return 'header.login.invalidUserLogin';
			}
		}
		return '';
	}

	INDRA_handleInputChange(e) {
		this.form.controls[e.target.id].setValue(e.target.value.trim());
	}

	INDRA_gotoURL() {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const key = 'externalURLs.recoverPassword';
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageCode}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	INDRA_serviceError() {
		// return true if login service error
		return this.account != '';
	}
	
	INDRA_errorTitle() {
		if (this.account != '')
			return '';
		return this.INDRA_getTranslation('header.login.text.error');
	}

	getPasswordInputType() {
		return this.passwordIsHidden ? 'password' : 'text';
	}

	getPasswordInputAriaLabel() {
		return this.passwordIsHidden ? 'Show password' : 'Hide password';
	}

	handleShowHideAnimation(anim: any) {
		this.anim = anim;
	}

	animateShowHidePassword() {
		if (this.passwordIsHidden) {
			this.passwordIsHidden = false;
			this.anim.setDirection(1);
			this.anim.play();
		} else {
			this.passwordIsHidden = true;
			this.anim.setDirection(-1);
			this.anim.play();
		}
	}

	INDRA_handleSignUp() {
		this.store.dispatch(new UserActions.PutCancelLogIn(true));
		this.closeModal();
		/* note: from post sprint 8 merge
		if (this.isCorporate)
			window.open('https://www.tapcorporate.com/pt-pt/adesao', '_blank');
		else
		*/
		this.sidebarService.openSidebar(['sign-up']);
	}

	private INDRA_handleLoginErrors(errorList: any ) {
		for (let i = 0; i < errorList.length; i++) {
			if (errorList[i].code && errorList[i].desc) {
				switch (errorList[i].code) {
					case 'FFP01.02': 
							this.loginErrorMessage = this.translatedMessagesKey.invalidStatus;
						break;
					case '401':
						if (errorList[i].desc.includes(this.messages.accountLocked)) {
							this.loginErrorMessage = this.translatedMessagesKey.accountLocked;
							this.loginErrorMessageTitle = this.translatedMessagesTitleKey.accountLocked;
						}  else if (errorList[i].desc.includes(this.messages.invalidCredentials) || (errorList[i].desc.includes(this.messages.invalidUsernameOrPassword))) {
							// gets the number of invalid attempts provided in error message
							this.invalidAttempts = errorList[i].desc.slice(-1);
							this.loginErrorMessage = this.translatedMessagesKey.invalidCredentials;
							this.loginErrorPasswordRelated = true;
							return;
						}  else if (errorList[i].desc.includes(this.messages.unauthorized)) {
							this.loginErrorMessage = this.translatedMessagesKey.unauthorized;
							return;
						}  else {
							this.loginErrorMessage = errorList[i].desc;
							return;
						}
						break;
					case '404':
						this.loginErrorMessage = this.translatedMessagesKey.userUnknown;
						this.loginErrorUsernameRelated = true;
						return;
					case '406':
						this.loginErrorMessage = this.translatedMessagesKey.emailMultipleClients;
						this.loginErrorUsernameRelated = true;
						return;
					case '422':
						this.loginErrorMessage = this.translatedMessagesKey.loginServiceUnavailable;
						this.loginErrorMessageTitle = this.translatedMessagesTitleKey.loginServiceUnavailable;
						return;
					case '503':
						this.loginErrorMessage = this.translatedMessagesKey.loginServiceUnavailable;
						this.loginErrorMessageTitle = this.translatedMessagesTitleKey.loginServiceUnavailable;
						return;
					case '500':
						this.loginErrorMessage = this.translatedMessagesKey.tryLater;
						this.loginErrorMessageTitle = this.translatedMessagesTitleKey.loginServiceUnavailable;
						return;
					default:
						this.loginErrorMessage = errorList[i].desc;
						return;
				}
			} else {
				this.loginErrorMessage = errorList[i].desc;
				return;
			}
		}

	}
	
	INDRA_getLoginErrorMessage() :string {
		if(this.loginErrorMessage){
			return this.loginErrorMessage;
		} else {
			if (this.account != '') {
				return 'You can only login with the account you have used to save the original price of this booking.';
			}
			return;
		}
	}
	
	INDRA_recoverTP() {
		this.store.dispatch(new UserActions.PutCancelLogIn(true));
		return window.open(this.ibeAdminConfigService.getConfigurationValue('externalURLs.recoverTP'));
	}
	
	/* from post-sprint 8 client code merge
	TAP_getLabel(): string {
		return this.label;
	}
	*/
	
	async initGoogleAuth(): Promise<void> {
		//  Create a new Promise where the resolve
		// function is the callback passed to gapi.load
		const pload = new Promise((resolve) => {
			gapi.load('auth2', resolve);
		});

		// When the first promise resolves, it means we have gapi
		// loaded and that we can call gapi.init
		return pload.then(async () => {
		await gapi.auth2
			.init({ client_id: SOCIAL_GOOGLE_KEY })
			.then(auth => {
				this.gapiSetup = true;
				this.authInstance = auth;
			});
		});
	}
	
	async INDRA_submitGLogin(): Promise<gapi.auth2.GoogleUser> {
		// Initialize gapi if not done yet
		if (!this.gapiSetup) {
		  await this.initGoogleAuth();
		}

		// Resolve or reject signin Promise
		return new Promise(async () => {
			await this.authInstance.signIn().then(user => this.user = user, error => this.error = error);
			if(this.user && this.user.isSignedIn()) {
				this.INDRA_socialLogin(this.user.getId(), LOGIN_AUTENTICATION_TYPE_GOOGLE);
			}
		});
	}
	
	async checkIfUserAuthenticated(): Promise<boolean> {
		// Initialize gapi if not done yet
		if (!this.gapiSetup) {
			await this.initGoogleAuth();
		}
		return this.authInstance.isSignedIn.get();
	}

	INDRA_printStyle(id: string) {
		if (id == 'password') {
			return {
				'is-filled': this.PassFilled,
				'is-focused': this.PassFocused,
				'has-error': (this.isInvalid('password') || this.loginErrorPasswordRelated) && this.isSubmitted
			};
		}
		else {
			return {
				'is-filled': this.UserFilled,
				'is-focused': this.UserFocused,
				'has-error': (this.isInvalid('login') || this.loginErrorUsernameRelated) && this.isSubmitted
			};
		}
	}

	INDRA_handleFocus(e) {
		if (e.target.id == 'login-password')
			this.PassFocused = true;
		else
			this.UserFocused = true;
	}

	INDRA_handleBlur(e) {
		if (e.target.id == 'login-password') {
			this.PassFocused = false;
			this.PassFilled = e.target.value != '';
		}
		else {
			this.UserFocused = false;
			this.UserFilled = e.target.value != '';
			this.INDRA_handleInputChange(e);
		}
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
}
